var HtmlSettings = new (class HtmlSettings extends AbstractModule {
  /**
   * Sets up variables containing building functions.
   * All pre and post custom card blocks function must be registered here.
   * Finally will call a method to bind all those functions.
   */
  constructor() {
    super("HtmlSettings")

    this.preBuildFunctions = {
      "switch-view-block": this.preBuildSwitchViewBlock,
      "team-profile-pictures": this.preBuildTeamProfilePictures,
      "help-center-form": this.preBuildInputForm,
      "newsletter-form": this.preBuildInputForm,
      "svg-button": this.preBuildSvgButton,
      "phone-button": this.preBuildPhoneButton
    }

    this.postBuildFunctions = {
      "switch-view-block": this.postBuildSwitchViewBlock,
      "team-profile-pictures": this.postBuildTeamProfilePictures,
      "help-center-form": this.postBuildHelpCenterForm,
      "newsletter-form": this.postBuildNewsletterForm,
      "svg-button": this.postBuildSvgButton,
      "script-block": this.postBuildScriptBlock
    }

    this._bindMethodTriggers()
  }

  /**
   * Binds module object to methods to access it in their context.
   * @param {Object} methodTrigger
   * @returns {Object}
   */
  _bindSelfToMethods(methodTrigger) {
    let methodLabel = Object.keys(methodTrigger)

    methodLabel.forEach((methodLabel) => {
      methodTrigger[methodLabel] = methodTrigger[methodLabel].bind(this)
    })

    return(methodTrigger)
  }

  /**
   * Registers module instance to pre and post build functions.
   */
  _bindMethodTriggers() {
    this.preBuildFunctions = this._bindSelfToMethods(this.preBuildFunctions)
    this.postBuildFunctions = this._bindSelfToMethods(this.postBuildFunctions)
  }

  /**
   * Replaces any detected variable in the text passed as argument and replace them by data associated.
   * @param {String} text
   * @returns {String}
   */
  _loadChatboxVariableSyntax(text) {
    if (!(typeof text === "string")) {
      return ("")
    }

    text = text.replace(/%{(\w+)}/g, function (match, p1) {
      void match

      return (`{{${p1}}}`)
    })

    return (text)
  }

  /**
   * Replaces Homepage texts names by their associated translation for the current Chatbox language.
   * @param {Object} data
   * @returns {Object}
   */
  _loadHomepageTexts(data) {
    data.settings_format.forEach((setting_format) => {
      if (setting_format.type === "string") {
        let textTranslation =
          this.app._homepage_texts[data.settings[setting_format.id]] ||
          this.app._homepage_texts_fallback[data.settings[setting_format.id]]

        if (!textTranslation) {
          textTranslation = data.settings[setting_format.id]
          Utils.publicLog(`No text fallback found for: "${data.settings[setting_format.id]}"`)
        }

        data.settings[setting_format.id] = this._loadChatboxVariableSyntax(textTranslation)
      }
    })

    return (data.settings)
  }

  /**
   * Triggers proper pre-build function depending on the block's type
   * @param {String} blockType
   * @param {Object} data
   * @returns {Object}
   */
  loadPreBuildSettings(blockType, data) {
    data.settings = this._loadHomepageTexts(data)

    if (!this.preBuildFunctions[blockType]) {
      return(data.settings)
    }

    return(this.preBuildFunctions[blockType](data.settings))
  }

  /**
   * Triggers proper post-build function depending on the block's type
   * @param {String} blockType
   * @param {Object} data
   * @returns {Object}
   */
  loadPostBuildSettings(blockType, data) {
    if (!this.postBuildFunctions[blockType]) {
      return(data)
    }

    return(this.postBuildFunctions[blockType](data))
  }

  /**
   * Pre build function for switch-view block.
   * @param {Object} settings
   * @returns {Object}
   */
  preBuildSwitchViewBlock(settings) {
    switch (settings.style) {
      case "primary":
        settings.style = HtmlBuilder.injectWidgetData("background-color: ${widget.window_color}; color: ${widget.title_color}")
        settings.class = "slaask-widget-homepage-cta"
        break
      default:
        settings.style = HtmlBuilder.injectWidgetData("color: ${widget.window_color};")
        settings.class = "slaask-widget-homepage-cta2"
        break
    }

    if (Views.getByName(settings.view).soapy) {
      settings.hide = false
    }

    return(settings)
  }

  /**
   * Post build function for switch-view block.
   * @param {Object} settings
   * @returns {Object}
   */
  postBuildSwitchViewBlock(data) {
    if (data.domElement === null) {
      return data
    }

    data.domElement.addEventListener("click", function(event) {
      event.preventDefault()
      data.settings.view == "conversation" ? Conversations.clickOnCta() : Views.jumpToViewByName(data.settings.view)
    })
  }

  /**
   * Pre build function for team-profile-pictures block.
   * @param {Object} settings
   * @returns {Object}
   */
  preBuildTeamProfilePictures(settings) {
    const shouldHideAvatars = !(this.app._reply_mode == 'personalized' && this.app._diplay_members);
    if (shouldHideAvatars) {
      settings.hide = true;
    }
    
    const limit = settings.hide === true ? 0 : settings.limit
    let shuffledUsers = Utils.shuffleArray(this.app._widget_users)

    for (let i = 0; i < shuffledUsers.length && i < limit; i++) {
      settings.list.push({
        source: shuffledUsers[i].image
      })
    }

    return(settings)
  }

  /**
   * Post build function for team-profile-pictures block.
   * @param {Object} settings
   * @returns {Object}
   */
  postBuildTeamProfilePictures(data) {
    if (this.app._reply_mode != 'personalized' || !this.app._diplay_members) {
      return data
    }

    let usersRemoved = false

    if (data.domElement === null) {
      return data
    }

    data.domElement.addEventListener("error", function(event) {
      void event

      data.domElement.setAttribute("src", HtmlBuilder.injectWidgetData("${widget.support_img}"))
    })

    Conversations.on('adding-summary', (conversation, containerEl) => {
      void conversation

      if (!usersRemoved && (containerEl.id === "slaask-widget-homepage-conversations-users")) {
        let users = Dom.findAll('widget', '#slaask-widget-homepage-conversations-users .slaask-widget-homepage-conversations-users-image')

        for (let i = 0 ; i < users.length ; i++) {
          Utils.removeElement(users[i])
        }

        data.domElement.classList.add('slaask-widget-homepage-conversations-current')

        usersRemoved = true
      }
    })

    data.domElement.id = 'slaask-widget-homepage-conversations-users'

    return(data)
  }

  /**
   * Pre build function for input-form block.
   * @param {Object} settings
   * @returns {Object}
   */
  preBuildInputForm(settings) {
    settings.icon_string = Svg.getIcon(settings.submit_icon, { color: "#ffffff" })

    return(settings)
  }

  /**
   * Help center search button dynamic build.
   * @param {Object} data
   * @returns {Object}
   */
  postBuildHelpCenterForm(data) {
    let helpcenterForm = data.domElement.getElementsByClassName("slaask-widget-homepage-input-form slaask-widget-homepage-form")[0]

    if (helpcenterForm) {
      helpcenterForm.addEventListener("submit", async (event) => {
        event.preventDefault()

        let formElements = {
          input: helpcenterForm.getElementsByClassName("slaask-input slaask-input-survey slaask-widget-homepage-input")[0],
          submitImage: helpcenterForm.getElementsByClassName("slaask-widget-homepage-submit-image")[0],
          loader: helpcenterForm.getElementsByClassName("slaask-homepage-loader-wrapper")[0],
          faqContainer: data.domElement.getElementsByClassName("slaask-widget-homepage-form-content")[0]
        }

        Object.keys(formElements).forEach(function(key) {
          if (!formElements[key]) {
            console.error(`Undefined block layout: ${key}`)
          }
        })

        if(formElements.input.value != "") {
          let query = formElements.input.value

          Utils.addClass(formElements.submitImage, "slaask-hidden")
          Utils.removeClass(formElements.loader, "slaask-hidden")

          let moreButton = data.domElement.getElementsByClassName("slaask-widget-homepage-more-faq-button")[0]

          if (moreButton) {
            moreButton.setAttribute('href', `${this.app._help_center_url}/hc/?q=${query}`)
            Utils.removeElement(moreButton)
          }

          let availableFaqs = await Faqs.fetchFaqsQuery(query, false, true)

          formElements.faqContainer.innerHTML = ''
          const helpcenterContent = formElements.faqContainer.ownerDocument.createElement('div')
          helpcenterContent.className = 'slaask-widget-homepage-helpcenter-content'
          formElements.faqContainer.appendChild(helpcenterContent)

          if (availableFaqs.length == 0) {
            helpcenterContent.innerHTML = '<p>' + data.settings.form_no_results.replace('{{search}}', query).replace('""', '"' + query + '"') + '<br>' + data.settings.form_try_again + '</p>'

            Utils.removeClass(formElements.submitImage, "slaask-hidden")
            Utils.addClass(formElements.loader, "slaask-hidden")
          } else {
            helpcenterContent.innerHTML = '<p>' + data.settings.form_results.replace('{{search}}', query).replace('""', '"' + query + '"') + '</p>'

            for (var i = 0; i < availableFaqs.length; i++) {
              let itemStyle
              if(i == 0) {
                itemStyle = ' style="border-top: 1px solid #e6ecf5;"'
              } else {
                itemStyle = ''
              }

              helpcenterContent.innerHTML = helpcenterContent.innerHTML + '<a id="homepage-faq-' + availableFaqs[i].objectID + '" data-url="' + availableFaqs[i].url + '" href="#" class="slaask-widget-homepage-helpcenter-item"' + itemStyle + '><div class="slaask-widget-homepage-helpcenter-item-title" style="color:' + this.app._window_color + '">' + availableFaqs[i].title + '</div><div class="slaask-widget-homepage-helpcenter-item-content" >' + availableFaqs[i].description + '</div></a>'
            }

            data.domElement.insertAdjacentHTML('beforeend', '<a href="' + this.app._help_center_url + '/hc/?q=' + encodeURIComponent(query) + '" target="_blank" class="slaask-widget-homepage-cta slaask-widget-homepage-more-faq-button" style="background-color:#FFF!important;color:' + this.app._window_color + ';border:1px solid ' + this.app._window_color + '">' + data.settings.form_more + '</a>')

            formElements.submitImage.classList.remove("slaask-hidden")
            formElements.loader.classList.add("slaask-hidden")

            let faqElements = data.domElement.getElementsByClassName("slaask-widget-homepage-helpcenter-item")

            for (let i = 0; i <= faqElements.length - 1; i++) {
              faqElements[i].addEventListener("click", (e) => {
                e.preventDefault()
                Views.jumpToViewByName('iframe', Utils.dataSet(faqElements[i], 'url'))
              })
            }

            let homepageViewEl = Views.getByName('homepage').element
            homepageViewEl.scrollTo({
              top: data.domElement.offsetTop
                    - parseInt(Dom.get('widget').window.getComputedStyle(homepageViewEl)['padding-left']),
              left: 0,
              behavior: 'smooth'
            })
          }
        }
      })
    }

    return(data)
  }

  /**
   * Newsletter email register input field and button dynamic build.
   * @param {Object} data
   * @returns {Object}
   */
  postBuildNewsletterForm(data) {
    let form = data.domElement.getElementsByClassName("slaask-widget-homepage-input-form slaask-widget-homepage-form")[0]

    if (form) {
      // Add aria-label to submit button
      let submitButton = form.getElementsByClassName("slaask-widget-homepage-submit")[0]
      if (submitButton) {
        submitButton.setAttribute("aria-label", Wording.send_message);
      }

      form.addEventListener("submit", async (event) => {
        event.preventDefault()

        var email = form.getElementsByClassName("slaask-input slaask-input-survey slaask-widget-homepage-input")[0].value
        const submit_icon = form.getElementsByClassName("slaask-widget-homepage-submit-image")[0]
        const loader = form.getElementsByClassName("slaask-homepage-loader-wrapper")[0]
        const content = data.domElement.getElementsByClassName("slaask-widget-homepage-form-content")[0]

        if(/^[a-zA-Z0-9.!#$%&'*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
          Utils.addClass(submit_icon, "slaask-hidden")
          Utils.removeClass(loader, "slaask-hidden")

          await Ajax.call('/api/add_to_newsletter', { key: this.app._api_key, token: this.app._guest_token, email: email })

          content.innerHTML =  "<p>" + data.settings.form_success + email + "</p>"
          Utils.removeElement(form)
        } else {
          const content = data.domElement.getElementsByClassName("slaask-widget-homepage-form-content")[0]

          content.innerHTML =  '<p class="newsletter-fail">' + data.settings.form_fail + '</p>'
        }
      })
    }

    return(data)
  }

  /**
   * Pre build function for svg-button block
   * @param {Object} settings
   * @returns {Object}
   */
  preBuildSvgButton(settings) {
    settings.svg_string = Svg.getIcon(settings.svg, { color: this.app._window_color })

    return(settings)
  }

  /**
   * Post build function for svg-button block.
   * @param {Object} settings
   * @returns {Object}
   */
  postBuildSvgButton(data) {
    if (!data.settings.card_click) {
      return data
    }

    let isCardContainer = false
    let node = data.domElement

    while (!isCardContainer) {
      isCardContainer = node.className.includes("slaask-widget-homepage-card")
      node = node.parentNode

      if (!node) {
        console.warn("Cannot find homepage-card element parent, event not registered but rendered was OK.")

        return data
      }
    }

    Utils.addClass(node, "slaask-widget-homepage-card-link")


    node.addEventListener("click", function() {
      Dom.addClass('widget', 'slaask-slide-from-right')
      Dom.addClass('widget', 'slaask-widget-open-' + data.settings.view)
      Views.jumpToViewByName(data.settings.view)
    })

    return data
  }

  /**
   * Pre build function for phone-button block
   * @param {Object} settings
   * @returns {Object}
   */
  preBuildPhoneButton(settings) {
    settings.svg_string = Svg.getIcon(settings.svg, {color: "#ffffff"})

    return settings
  }

  postBuildScriptBlock(data) {
    data.domElement.addEventListener('click', () => {
      eval(data.settings.script)
    })

    return data
  }
})
